{
    "systems": "Systems",
    "deploy": "Deploy",
    "systemName": "System Name",
    "notes": "Notes",
    "createdOn": "Created On:",
    "by": "by",
    "updatedOn": "Updated On:",
    "systemAttributes": " System Attributes",
    "error": "Error",
    "newName": "New Name",
    "cancel": "Cancel",
    "create": "Create",
    "copy": "Copy",
    "refresh": "Refresh",
    "back": "Back",
    "next": "Next",
    "ok": "Ok",
    "systemCreateTitle": "Create New System",
    "systemNameInvalid": "System names must be at least 3 characters, begin with a letter and may only contain letters, numbers and the underscore character",
    "sysetmCreateComment": "Please choose a new name for your system and then click the create button",
    "systemNameDuplicate": "The system name already exists, please choose a different name",
    "areYouSure": "Are you sure?",
    "checkingSystemSave": "Are you sure you would like to save your changes to the server?",
    "thanks": "Thanks!",
    "systemSaved": "Your changes have been saved successfully",
    "unknownError": "Unknown error returned from server, please try again",
    "checkingSystemDeletion": "Are you sure you would like to delete this system?",
    "systemDeleted": "The system was successfully deleted",
    "copyFrom": "Copy from",
    "systemCopyTitle": "Copy Existing System",
    "systemCopyComment": "Please choose a new name for your system and the system you would like to duplicate. Then click copy",
    "systemDeployTitle": "Deploy System(s)",
    "systemDeleteTitle": "Delete System",
    "systemDeployComment": "Please choose the systems you would like to deploy, then click Next.",
    "deploymentName": "Deployment Name",
    "exportSystems": "Export System(s)",
    "dataSourceName": "Datasource Name",
    "deploymentNameInvalid": "Deployment names must begin with a letter and may only contain letters, numbers and the underscore character",
    "downloadInProgress": "Download in progress",
    "deleting": "Deleting",
    "pleaseBePatientDeleteInProgress": "Please be patient delete in progress",
    "deployingSystems": "Deploying System(s)",
    "systemDeploymentMessage": "Generating Deployment Package..."
}
